import React from "react";
import { Trash, Edit as EditIcon } from "./../../../../assets/images/svg";
import { StoreActionsMenu } from "./StoreActionMenu";

export const StoreRow = ({ item, onMenuItemClick, handlePopup }) => {
  const { orgName } = item;
  if (item.type === "header") {
    return <div style={{ fontWeight: "bold", marginBottom: 10, fontSize: "22px" }}>{orgName}</div>;
  }

  const { id, name } = item.store;

  return (
    <>
      <li color="dark1" className="group__item" key={id}>
        <div className="group__el text">{name}</div>
        <div className="group__el icons">
          <div className="group__el stores__menu stores__menu--transparent">
            <StoreActionsMenu onMenuItemClick={onMenuItemClick} item={item} />
          </div>

          <div className="group__el edit">
            <span
              className="group__icon"
              onClick={() => handlePopup(item.store, "edit")}
              title="Edit"
            >
              <EditIcon />
            </span>
          </div>
          <div className="group__el delete">
            <span className="group__icon" onClick={() => handlePopup(item, "delete")}>
              <Trash color="#FF0000" />
            </span>
          </div>
        </div>
      </li>
    </>
  );
};
